import { AddButton, ButtonProps } from "@/shared/form/button";
import { useTranslations } from "use-intl";

export function AddStepButton(props: ButtonProps) {
  const t = useTranslations("AddStepButton");

  return <AddButton {...props}>{t("Add step")}</AddButton>;
}
